/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {type FC} from 'react';
import {useDocumentTitle} from './hooks/useDocumentTitle';
import {usePopulateUserStore} from './hooks/usePopulateUserStore';
import {useUpdateContactImports} from './hooks/useUpdateContactImports';
import Router from './Router';

export const App: FC = () => {
  useUpdateContactImports();
  useDocumentTitle();
  usePopulateUserStore();
  return <Router />;
};
